import React from "react";
import PropTypes from "prop-types";
import { Input, Label, GridColumn, Img } from "arv-reactcomponents";


const PaymentCard = props => {
  const {
    name,
    code,
    image,
    className,
    onChange,
    isChecked,
    selectedClassName,
    selectedPayment,
  } = props.paymentCardDetails
  return (
    <GridColumn className="nwc-grid-col-sm-3 nw-paymentcard-option">
      <Label
        htmlFor={`nw-paymentcard-${name}`}
        className="nw-paymentcard-radio"
      >
        <Input
          className="nwc-inp-radio-primary nwc-hide"
          id={`nw-paymentcard-${name}`}
          name={code}
          key={code}
          type="radio"
          value={code}
          onChange={e => {
            onChange(e, selectedPayment);
          }}
          checked={isChecked}
        />
        <div className={`${selectedClassName} nw-paymentcard-unit`}>
          <div className="nw-paymentcard-content">
            <Img
              className="nw-paymentcard-img"
              src={image}
            />
            <div className="nw-paymentcard-name">
              {name}
            </div>
          </div>
        </div>
      </Label>
    </GridColumn>
  );
}

PaymentCard.propTypes = {
  paymentCardDetails: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired,
    selectedClassName: PropTypes.string.isRequired,
    selectedPayment: PropTypes.shape({}).isRequired,
  })
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: PaymentCard,
  component: PaymentCard,
};

export default ProjectComponent;


// WEBPACK FOOTER //
// ./src/component/PaymentWallet/PaymentCard/index.js